export const monthColumns = [
  {
    field: 'jan',
    headerName: 'Jan',
    width: 110,
  },
  {
    field: 'feb',
    headerName: 'Feb',
    width: 110,
  },
  {
    field: 'mar',
    headerName: 'Mar',
    width: 110,
  },
  {
    field: 'apr',
    headerName: 'Apr',
    width: 110,
  },
  {
    field: 'may',
    headerName: 'May',
    width: 110,
  },
  {
    field: 'jun',
    headerName: 'Jun',
    width: 110,
  },
  {
    field: 'jul',
    headerName: 'Jul',
    width: 110,
  },
  {
    field: 'aug',
    headerName: 'Aug',
    width: 110,
  },
  {
    field: 'sep',
    headerName: 'Sep',
    width: 110,
  },
  {
    field: 'oct',
    headerName: 'Oct',
    width: 110,
  },
  {
    field: 'nov',
    headerName: 'Nov',
    width: 110,
  },
  {
    field: 'dec',
    headerName: 'Dec',
    width: 110,
  },
];

export const day31Columns = [
  { field: 'd1', headerName: 'd1', width: 80 },
  { field: 'd2', headerName: 'd2', width: 80 },
  { field: 'd3', headerName: 'd3', width: 80 },
  { field: 'd4', headerName: 'd4', width: 80 },
  { field: 'd5', headerName: 'd5', width: 80 },
  { field: 'd6', headerName: 'd6', width: 80 },
  { field: 'd7', headerName: 'd7', width: 80 },
  { field: 'd8', headerName: 'd8', width: 80 },
  { field: 'd9', headerName: 'd9', width: 80 },
  { field: 'd10', headerName: 'd10', width: 80 },
  { field: 'd11', headerName: 'd11', width: 80 },
  { field: 'd12', headerName: 'd12', width: 80 },
  { field: 'd13', headerName: 'd13', width: 80 },
  { field: 'd14', headerName: 'd14', width: 80 },
  { field: 'd15', headerName: 'd15', width: 80 },
  { field: 'd16', headerName: 'd16', width: 80 },
  { field: 'd17', headerName: 'd17', width: 80 },
  { field: 'd18', headerName: 'd18', width: 80 },
  { field: 'd19', headerName: 'd19', width: 80 },
  { field: 'd20', headerName: 'd20', width: 80 },
  { field: 'd21', headerName: 'd21', width: 80 },
  { field: 'd22', headerName: 'd22', width: 80 },
  { field: 'd23', headerName: 'd23', width: 80 },
  { field: 'd24', headerName: 'd24', width: 80 },
  { field: 'd25', headerName: 'd25', width: 80 },
  { field: 'd26', headerName: 'd26', width: 80 },
  { field: 'd27', headerName: 'd27', width: 80 },
  { field: 'd28', headerName: 'd28', width: 80 },
  { field: 'd29', headerName: 'd29', width: 80 },
  { field: 'd30', headerName: 'd30', width: 80 },
  { field: 'd31', headerName: 'd31', width: 80 },
];
